export default __webpack_public_path__ + "media/images/front/about/mypage-16916b7a06e6a68ac139855b95e068ec.png";